import { ArrowRight } from '@dreamstack/icons/src/icon-components/ArrowRight'
import { cn } from '@dreamstack/util/src/cn'
import { motion } from 'framer-motion'
import Link from 'next/link'
import type { FunctionComponent } from 'react'
import { StyledTileHeader } from '../ActionTile'
import {
  AnimateIconTranslationRight,
  useAnimateIconTranslationRight,
} from '../layout/AnimateIconTranslation'
import { HeadingH4 } from '../layout/Texts'

const wrapperBaseClass =
  'bg-accentroGray-full bg-center justify-between p-px-16 h-px-128 md:h-px-196 md:p-px-24 lg:h-px-320 lg:p-px-48 flex cursor-pointer bg-cover'

const arrowBaseClass = 'text-accentroWhite-full h-px-32 w-px-32'
const arrowBigClass = 'lg:h-px-64 lg:w-px-64'

export const CallToActionTile: FunctionComponent<
  React.PropsWithChildren<{
    caption: string
    href: string
    big?: boolean
    backgroundImageUrl?: string
    targetBlank?: boolean
  }>
> = ({ caption, href, big, backgroundImageUrl, targetBlank }) => {
  const target = targetBlank ? '_blank' : '_self'
  const { onHoverStart, controls } = useAnimateIconTranslationRight()
  return (
    <Link href={href} passHref legacyBehavior>
      <motion.a onHoverStart={onHoverStart} target={target}>
        <div
          className={wrapperBaseClass}
          style={
            backgroundImageUrl
              ? {
                  background: `linear-gradient( rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.8) ), url(${backgroundImageUrl})`,
                }
              : undefined
          }
        >
          {big ? (
            <StyledTileHeader className="flex items-end text-accentroWhite-full break-all">
              {caption}
            </StyledTileHeader>
          ) : (
            <HeadingH4 className="flex items-end text-accentroWhite-full pb-px-32 md:pb-0 break-normal">
              {caption}
            </HeadingH4>
          )}
          <div className="flex justify-end items-end">
            <AnimateIconTranslationRight animate={controls}>
              <ArrowRight
                className={cn(arrowBaseClass, big && arrowBigClass)}
              />
            </AnimateIconTranslationRight>
          </div>
        </div>
      </motion.a>
    </Link>
  )
}
